import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-copy-code-popup',
    standalone: true,
    imports: [TranslateModule, CommonModule, MatIconModule],
    templateUrl: './copy-code-popup.component.html',
    styleUrl: './copy-code-popup.component.scss',
})
export class CopyCodePopupComponent {
    copied = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { referralCode: string },
        private dialogRef: MatDialogRef<CopyCodePopupComponent>
    ) {}

    closeDialog() {
        this.dialogRef.close();
    }

    copyReferralCode() {
        const code = this.data.referralCode;
        navigator.clipboard.writeText(code).then(() => {
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 3000);
        });
    }
}
